'use client';
import Image from 'next/image';
import clsx from 'clsx';

import { DSText } from '@bgzt/ds';
import { LinkByEnvironment, Section, Spacing } from '~/components';
import { SHOPS } from '~/constants';
import globalStyles from '~/styles/utils.module.css';

import IcNewBadge from './new.svg';

import styles from './ShopEntryPoints.module.css';

type Props = {
  newBadge?: boolean;
};
export const ShopEntryPoints = ({ newBadge = false }: Props) => {
  const shops = Object.values(SHOPS);

  return (
    <Section fullWidth>
      <div className={styles.shopEntryHeader}>
        <DSText typography="subTitle2.bold" color="neutral-strong">
          일본 오프라인 샵을 그대로
        </DSText>
        {newBadge && <span className={styles.newBadge}>NEW</span>}
      </div>
      <Spacing height={16} />
      <ul className={clsx(styles.shopEntryList, globalStyles.scrollXHidden)}>
        {shops.map((shop) => (
          <li className={styles.shopEntryItem} key={shop.id}>
            <LinkByEnvironment href={`/shop/${shop.id}`} target="_blank">
              <div className={styles.shopEntryCard}>
                <div className={styles.shopEntryCardImage}>
                  <Image
                    src={shop.images.entryCard}
                    alt={shop.shopNameKor}
                    width={140}
                    height={80}
                    unoptimized
                    priority
                  />
                </div>

                <div className={styles.shopEntryCardContent}>
                  <div className={styles.shopEntryCardLogo}>
                    <Image src={shop.images.logo} alt={shop.shopNameKor} width={44} height={44} unoptimized priority />
                  </div>
                  <div className={styles.shopEntryCardText}>
                    <DSText typography="label2.bold" color="neutral-strong">
                      {shop.shopNameKor}
                    </DSText>
                    {shop.isNew && <IcNewBadge />}
                  </div>
                  <div className={styles.shopEntryCardText}>
                    <DSText typography="label3.medium" color="neutral-subtle">
                      {shop.shortDesc}
                    </DSText>
                  </div>
                </div>
              </div>
            </LinkByEnvironment>
          </li>
        ))}
      </ul>
    </Section>
  );
};
